import { render, staticRenderFns } from "./Party3ds.vue?vue&type=template&id=01d3989a"
import script from "./Party3ds.vue?vue&type=script&lang=js"
export * from "./Party3ds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports